import { Heading, PackageSelect, Paragraph } from '@graftcode/design-system'

import { useCodeStore } from '@/core/stores/codeStore'

import styles from './NoTechnologyPlaceholder.module.scss'

export function NoTechnologyPlaceholder() {
  const { technologies, suggestedTechnologies, setSelectedTechnology } = useCodeStore()

  const onValueChange = (value: string) => {
    setSelectedTechnology(value)
  }

  return (
    <div className={styles.noTech}>
      <Heading type="h6">Package type required</Heading>
      <Paragraph weight="regular" size="sm" className={styles.paragraph}>
        To see usage examples for this method, first choose a package type in the Installation panel.
      </Paragraph>
      <PackageSelect
        technologies={technologies}
        suggestedTechnologies={suggestedTechnologies}
        technologyPlaceholder="Select package type"
        onTechnologyChange={onValueChange}
      />
    </div>
  )
}
